<script lang="ts">
  import type { Studio } from '@bruce/api/common/studio'
  import { Icon, LinearProgress } from '@bruce/components'

  export let rating: NonNullable<Studio['rating']>

  const emojis = ['😍', '😄', '😐', '😕', '😡']
</script>

<div class="rating-container">
  <div class="ratings">
    {#each Object.values(rating.distribution).reverse() as ratingValue, index (index)}
      {@const percentage = (ratingValue / rating.total) * 100}
      <span>{emojis[index]}</span>
      <LinearProgress value={percentage} height={10} />
      <span class="percentage">
        {Math.round(percentage) < 1 ? '< 1' : Math.round(percentage)}%
      </span>
    {/each}
  </div>
  <div class="rating-summary">
    <div class="rating">
      <Icon icon="ph-star-fill" />
      <span>{Math.round(rating.average / 10) / 10}</span>
    </div>
    <div class="total">{rating.total} reviews</div>
  </div>
</div>

<style lang="scss">
  @use '@bruce/assets/css/breakpoints';

  .rating-container {
    display: flex;
    align-items: center;
    gap: 4em;

    @media screen and (max-width: breakpoints.$breakpoint-sm) {
      flex-direction: column-reverse;
      align-items: unset;
      width: 100%;
      gap: 1em;
    }

    .ratings {
      flex: 1;
      display: grid;
      align-items: center;
      column-gap: 1em;
      grid-template-columns: max-content 1fr max-content;
      --linear-progress-background-color: var(
        --rating-bar-color,
        var(--color-primary)
      );
      --linear-progress-color: var(--rating-bar-color, var(--color-primary));

      .percentage {
        text-align: right;
      }
    }

    .rating-summary {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5em;

      @media screen and (max-width: breakpoints.$breakpoint-sm) {
        flex-direction: row;
        gap: 1em;
      }

      .rating {
        display: flex;
        align-items: center;
        gap: 0.25em;
        font-size: 32px;
        --icon-margin: 0;

        @media screen and (max-width: breakpoints.$breakpoint-sm) {
          font-size: 24px;
        }
      }

      .total {
        font-size: 14px;
        opacity: 0.6;
      }
    }
  }
</style>
